var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVoucherCommand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9 6.96676H6.97735V11H8.9V6.96676Z",
    fill: "#5D6B72"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.96377 3C2.32693 3 1 4.32826 1 5.96676V10.9446H1.95472C2.53936 10.9446 3.00906 11.4186 3.00906 12C3.00906 12.5829 2.53701 13.0554 1.95472 13.0554H1V18.0332C1 19.6717 2.32693 21 3.96377 21H20.0362C21.6731 21 23 19.6717 23 18.0332V13.0554H22.0453C21.463 13.0554 20.9909 12.5829 20.9909 12C20.9909 11.4148 21.4645 10.9446 22.0453 10.9446H23V5.96676C23 4.31969 21.6654 3 20.0362 3H3.96377ZM2.90943 5.96676C2.90943 5.38388 3.38148 4.91136 3.96377 4.91136H20.0362C20.617 4.91136 21.0906 5.38153 21.0906 5.96676V9.19069C19.9256 9.58737 19.0815 10.6902 19.0815 12C19.0815 13.3041 19.9221 14.4117 21.0906 14.8095V18.0332C21.0906 18.6161 20.6185 19.0886 20.0362 19.0886H3.96377C3.38148 19.0886 2.90943 18.6161 2.90943 18.0332V14.8095C4.07787 14.4117 4.91849 13.3041 4.91849 12C4.91849 10.7008 4.08171 9.58867 2.90943 9.19016V5.96676Z",
    fill: "#5D6B72"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9 12.9668H6.97735V17H8.9V12.9668Z",
    fill: "#5D6B72"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoucherCommand);
export default __webpack_public_path__ + "static/media/VoucherCommand.fc6806da.svg";
export { ForwardRef as ReactComponent };